import queue from "../../icons/queue";
import create from "../../icons/create";
import createOutline from "../../icons/create-outline";
import demand from "../../icons/demand";
import ladder from "../../icons/ladder";
import joinQueue from "../../icons/joinQueue";
import leaveQueue from "../../icons/leaveQueue";
import follow from "../../icons/follow";
import unfollow from "../../icons/unfollow";
import approved from "../../icons/approved";
import people from "../../icons/people";
import demandOutline from "../../icons/demand-outline";
import starOutline from "../../icons/star-outline";
import replyOutline from "../../icons/reply-outline";
import commentOutline from "../../icons/comment-outline";
import arrowUpOutline from "../../icons/arrow-up-outline";
import arrowDownOutline from "../../icons/arrow-down-outline";
import category from "../../icons/category";
import list from "../../icons/list";
import arrowDown from "../../icons/arrow-down";
import arrowUp from "../../icons/arrow-up";
import bell from "../../icons/bell";
import search from "../../icons/search";
import menu from "../../icons/menu";
import plusCircle from "../../icons/plus-circle";
import listApproved from "../../icons/list-approved";
import listDisapproved from "../../icons/list-disapproved";
import itemApproved from "../../icons/item-approved";
import itemDisapproved from "../../icons/item-disapproved";
import home from "../../icons/home";
import timeline from "../../icons/timeline";
import star from "../../icons/star";
import creation from "../../icons/creation";
import logout from "../../icons/logout";
import admin from "../../icons/admin";
import userUnverified from "../../icons/user-unverified";
import demandDisapproved from "../../icons/demand-disapproved";
import detailArrowUp from "../../icons/detail-arrow-up";
import detailArrowDown from "../../icons/detail-arrow-down";
import itemInfoApproved from "../../icons/item-info-approved";
import itemImageApproved from "../../icons/item-image-approved";
import flag from "../../icons/flag";

export default {
  queue: {
    component: queue,
  },
  create: {
    component: create,
  },
  demand: {
    component: demand,
  },
  demandOutline: {
    component: demandOutline,
  },
  ladder: {
    component: ladder,
  },
  joinQueue: {
    component: joinQueue,
  },
  leaveQueue: {
    component: leaveQueue,
  },
  follow: {
    component: follow,
  },
  unfollow: {
    component: unfollow,
  },
  approved: {
    component: approved,
  },
  people: {
    component: people,
  },
  createOutline: {
    component: createOutline,
  },
  starOutline: {
    component: starOutline,
  },
  replyOutline: {
    component: replyOutline,
  },
  commentOutline: {
    component: commentOutline,
  },
  arrowUpOutline: {
    component: arrowUpOutline,
  },
  arrowDownOutline: {
    component: arrowDownOutline,
  },
  arrowDown: {
    component: arrowDown,
  },
  arrowUp: {
    component: arrowUp,
  },
  category: {
    component: category,
  },
  list: {
    component: list,
  },
  bell: {
    component: bell,
  },
  search: {
    component: search,
  },
  menu: {
    component: menu,
  },
  "plus-circle": {
    component: plusCircle,
  },
  "list-approved": {
    component: listApproved,
  },
  "list-disapproved": {
    component: listDisapproved,
  },
  "item-approved": {
    component: itemApproved,
  },
  "item-disapproved": {
    component: itemDisapproved,
  },
  home: {
    component: home,
  },
  timeline: {
    component: timeline,
  },
  star: {
    component: star,
  },
  creation: {
    component: creation,
  },
  logout: {
    component: logout,
  },
  admin: {
    component: admin,
  },
  "user-unverified": {
    component: userUnverified,
  },
  "demand-disapproved": {
    component: demandDisapproved,
  },
  "detail-arrow-up": {
    component: detailArrowUp,
  },
  "detail-arrow-down": {
    component: detailArrowDown,
  },
  "item-info-approved": {
    component: itemInfoApproved,
  },
  "item-image-approved": {
    component: itemImageApproved,
  },
  flag: {
    component: flag
  }
};
